module.exports = __webpack_public_path__ + "img/8A.3bd3a600.png";